import { render, staticRenderFns } from "./_BackgroundImageContents.vue?vue&type=template&id=0b90e0b6&"
import script from "./_BackgroundImageContents.vue?vue&type=script&lang=js&"
export * from "./_BackgroundImageContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports